import { LandingPageConfig } from 'rangeConfig/@types';
import bestaBgImage from '../../views/LandingPage/images/BESTA_background.jpg';
import bestaOpenDesignImg from '../../views/LandingPage/images/besta_landing_open_design.jpg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import bestaBrowseInspirationImg from '../../views/LandingPage/images/besta_browse_inspiration.jpg';
import bestaGalleryConfig from './bestaGalleryConfig';

const bestaLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: bestaBgImage
  },
  designFromScratch: {
    backgroundColor: '#CFBFAA',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: bestaOpenDesignImg
  },
  browseInspiration: {
    backgroundColor: '#D2BEA7',
    backgroundImgUrl: bestaBrowseInspirationImg,
    galleryConfig: bestaGalleryConfig
  }
};

export default bestaLandingPageConfig;
